/**
 * @ngdoc services
 * @memberof mercury.services
 * @name features
 * @description Service to manage the features
 */
angular.module('mercury.services.features')
.factory('features', ["$http", "$q", "settings", function featuresFactory($http, $q, settings) {

  var _promises = {};
  var _activeCompanyId;

  function _loadCompanyFeatures(companyId) {
    if (!_promises[companyId]) {
      _promises[companyId] = $http.get(settings.mercHost + '/features', {
        headers: {
          'x-loaded-company-id': companyId,
          'x-loaded-suppress-subscription-errors': '1'
        }
      });
    }
    return _promises[companyId];
  }

  function setActiveCompany(companyId) {
    _activeCompanyId = companyId;
  }

  function isEnabled(featureName) {
    var deferred = $q.defer();

    if (!_activeCompanyId) {
      deferred.reject();
    } else {
      _loadCompanyFeatures(_activeCompanyId).then(function(companyFeatures) {
        deferred.resolve(companyFeatures.data[featureName]);
      });
    }

    return deferred.promise;
  }

  return {
    setActiveCompany: setActiveCompany,
    isEnabled: isEnabled
  };
}]);
